/**
 * Video Feedback Module - Initialize all videos in carousel
 * 
 * This module ensures that all xo-video-cover elements in the
 * video-feedback carousel are properly initialized, not just the visible ones.
 */

(function() {
  function initializeAllVideos() {
    const carousel = document.querySelector('.video-feedback__carousel');
    if (!carousel) return;
    
    const videoCoverElements = carousel.querySelectorAll('xo-video-cover');
    let initialized = 0;
    
    videoCoverElements.forEach((videoCoverEl, index) => {
      if (typeof videoCoverEl.run === 'function') {
        // Check if already rendered
        if (!videoCoverEl.querySelector('video, iframe')) {
          videoCoverEl.run();
          initialized++;
        }
      }
    });
    
    console.log(`[video-feedback-init] Initialized ${initialized} videos`);
  }
  
  // Try multiple times to ensure all videos are initialized
  // including cloned elements from the carousel loop
  setTimeout(initializeAllVideos, 100);
  setTimeout(initializeAllVideos, 300);
  setTimeout(initializeAllVideos, 600);
  
  // Also initialize when the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', initializeAllVideos);
})();
